export default __webpack_public_path__ + "static/media/loginBackStrip.67fb4aad.png";